export default {
  isAuthenticated(state){
    return state.authenticated
  },
  getCompanies(state){
    return state.companies
  },
  getProviders(state){
    console.log(state.providers.sort((a, b) => a.name.localeCompare(b.name)));
    return state.providers.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  },
  getBrands(state){
    return state.brands
  },
  getProducts(state){
    return state.products
  },
  getUsers(state){
    return state.users
  },
  getUsersConcesionarios(state){
    var usersConcesionarios=[]
    for(var i=0; i<state.users.length; i++){
      for(var j=0; j<state.users[i].authorities.length; j++){
        if(state.users[i].authorities[j]=="ADMIN_CONCESIONARIO" || state.users[i].authorities[j]=="USER_CONCESIONARIO"){
          usersConcesionarios.push(state.users[i])
          break
        }
      }
    }
    return usersConcesionarios
  },
  getRolesConcesionario(state){
    var roles=[]
      roles.push("ADMIN_CONCESIONARIO")
      roles.push("USER_CONCESIONARIO")
    return roles
  },
  getTipoDoc(state){
    var tipoDocs=[]
    for(var i=0; i<state.catalogs.length; i++){
      if(state.catalogs[i].type=="TIPO_DOCUMENTO"){
        tipoDocs.push(state.catalogs[i])
      }
    }
    return tipoDocs
  },
  getCatalogs(state){
    return state.catalogs
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js